<template>
  <svg class="svg-icon" :title="title">
    <use :xlink:href="`#icon-${iconName}`" />
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName() {
      return this.iconClass
    }
  }
}
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor; /* 关键：让颜色继承父级 */
  overflow: hidden;
}
</style>